import { render, staticRenderFns } from "./answerck.vue?vue&type=template&id=2bde6b36&scoped=true"
import script from "./answerck.vue?vue&type=script&lang=js"
export * from "./answerck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde6b36",
  null
  
)

export default component.exports